import { configureStore } from "@reduxjs/toolkit";
import auth from "./auth/authSlice"

import global from "./global/globalSlice"


export const store = configureStore({
    reducer: {
        auth, global
    }
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch;